/* eslint-disable no-nested-ternary */
import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader, ListGroupItemHeading, ListGroup, ListGroupItem, Badge, FormGroup, ModalFooter } from "reactstrap";
import CloseButton from "react-bootstrap/CloseButton";
import { toast } from "react-toastify";
import SpinnerButton from "../../components/Button";
import ConfirmModal from "./Tabs/ConfirmModal";
import { handleErrors } from "../../services/handleErrors";
import { patchSubclientArea } from "../../services/areaServices";
import arraySorterer from "../../utils/sortArray";

const FiltroCentralizador = ({ toggle, centralizados, reloadTable }) => {
  const areasCentralizadas = centralizados.filter((opt) => opt.centralizado === true);
  const areasDisponibles = centralizados.filter((opt) => opt.centralizado == null || opt.centralizado === false);

  const [selected, setSelected] = useState(areasCentralizadas);
  const [available, setAvailable] = useState(areasDisponibles);
  const [confirmarModal, setConfirmarModal] = useState(false);

  const handleAddArea = (opt) => {
    const area = centralizados.find((el) => el.name === opt);
    setSelected((prevData) => {
      return arraySorterer([...prevData, area], "type");
    });
    const orderedAvailable = available.filter((item) => item.name !== opt);
    setAvailable(arraySorterer(orderedAvailable, "type"));
  };

  const handleRemoveArea = (opt) => {
    const area = centralizados.find((el) => el.name === opt);
    setAvailable((prevData) => {
      return arraySorterer([...prevData, area], "type");
    });
    const orderedSelected = selected.filter((item) => item.name !== opt);
    setSelected(arraySorterer(orderedSelected, "type"));
  };

  const handleSubmit = async () => {
    const centralizar1 = selected.forEach(async (area) => {
      const centralizadoBody = { centralizado: true };
      try {
        await patchSubclientArea(area.id, centralizadoBody);
        Promise.resolve();
      } catch (error) {
        handleErrors(error);
        toast.success("Error inesperado");
      }
    });
    const centralizar2 = available.forEach(async (area) => {
      const centralizadoBody = { centralizado: false };
      try {
        await patchSubclientArea(area.id, centralizadoBody);
        Promise.resolve();
      } catch (error) {
        handleErrors(error);
        toast.success("Error inesperado");
      }
    });
    Promise.all([centralizar1, centralizar2]).then(() => {
      toast.success("Las áreas se actualizaron correctamente");
      toggle();
      reloadTable();
    });
  };

  return (
    <>
      {confirmarModal && <ConfirmModal toggle={() => setConfirmarModal(!confirmarModal)} handleSubmit={handleSubmit} />}
      <Modal centered isOpen toggle={toggle} style={{ minWidth: "55%" }}>
        <ModalHeader toggle={toggle}>
          Áreas centralizadas
          <div className="areas-centralizadas">
            {selected.map((sel) => {
              return (
                <Badge
                  tag="div"
                  key={sel.type}
                  className="badge-pills filtro-centralizador-badge"
                  style={{
                    backgroundColor: `${sel.color}`,
                  }}
                >
                  {sel.name}
                  <CloseButton
                    className="badge-close-button"
                    value={sel.name}
                    key={sel.name}
                    onClick={(e) => {
                      handleRemoveArea(e.currentTarget.value);
                    }}
                  />
                </Badge>
              );
            })}
          </div>
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <ListGroup flush>
              <ListGroupItemHeading>Seleccióna una opción</ListGroupItemHeading>
              {available.map((opt) => {
                return (
                  <ListGroupItem style={{ border: "0px" }}>
                    <Badge
                      tag="div"
                      key={opt.id}
                      className="badge-pills filtro-centralizador-badge"
                      style={{
                        backgroundColor: `${opt.color}`,
                      }}
                      onClick={(e) => {
                        handleAddArea(e.currentTarget.innerHTML);
                      }}
                    >
                      {opt.name}
                    </Badge>
                  </ListGroupItem>
                );
              })}
            </ListGroup>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <FormGroup className="mb-0 px-3">
            <SpinnerButton className="btn btn-primary btn-block" onClick={() => setConfirmarModal(!confirmarModal)}>
              Centralizar
            </SpinnerButton>
          </FormGroup>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default FiltroCentralizador;
